import { render, staticRenderFns } from "./bdwg.vue?vue&type=template&id=3b4c5dec&scoped=true&"
import script from "./bdwg.vue?vue&type=script&lang=js&"
export * from "./bdwg.vue?vue&type=script&lang=js&"
import style0 from "./bdwg.vue?vue&type=style&index=0&id=3b4c5dec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4c5dec",
  null
  
)

export default component.exports